import React from 'react';
import { cn } from '../../../utils/cn';

const DeviceHeader = ({ 
  icon,
  title,
  subtitle,
  status,
  actions,
  onClick,
  className,
  ...props 
}) => {
  return (
    <div
      className={cn(
        'flex flex-col sm:flex-row sm:items-center justify-between',
        'p-4 cursor-pointer select-none',
        'hover:bg-gray-50 transition-colors duration-200',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {/* Icon + Info */}
      <div className="flex items-start sm:items-center gap-3 flex-1 min-w-0">
        {icon && (
          <div className={cn(
            'w-10 h-10 rounded-full flex items-center justify-center',
            'bg-gray-100 text-gray-600 transition-all duration-300',
            status === 'online' && 'bg-green-100 text-green-600',
            status === 'offline' && 'bg-red-100 text-red-600'
          )}>
            {icon}
          </div>
        )}
        <div className="flex flex-col min-w-0">
          <h4 className="text-base font-semibold text-gray-900 truncate max-w-full">
            {title}
          </h4>
          {subtitle && (
            <p className={cn(
              'text-sm truncate max-w-full',
              status === 'online' ? 'text-green-600' : 'text-gray-500'
            )}>
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Actions */}
      {actions && (
        <div className="mt-3 sm:mt-0 flex-shrink-0 flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default DeviceHeader;